import React from "react";
import { useSelector } from "react-redux";

const PrivateChatItem = ({
  flag,
  desc,
  valid_flag,
  scrollRef,
  caller_avatar,
  client_address,
  client_avatar_color,
}) => {
  const themeMode = useSelector((state) => state.themeMode);

  return (
    <div className="private-chat-main-section" ref={scrollRef}>
      <div className="chat-avatar">
        {valid_flag ? (
          <img
            alt="avatar"
            className="interviewer-avatar"
            src={caller_avatar}
          />
        ) : (
          <img
            alt="avatar"
            className="interviewer-avatar"
            src={`https://ui-avatars.com/api/?name=${client_address}&background=${client_avatar_color}&color=fff`}
          />
        )}
      </div>
      <div className="chat-content-section">
        <div
          className={`chat-content-title ${
            themeMode.themeMode
              ? "chat-content-title-dark"
              : "chat-content-title-light"
          }`}
        >
          {valid_flag ? "You" : client_address}
        </div>
        <div className="chat-content-desc">{desc}</div>
      </div>
    </div>
  );
};

export default PrivateChatItem;
